import { Pipe, PipeTransform } from '@angular/core';

/**
 * A financial year for display, always as "YYYY-YYYY": "2026-27",
 * "2026 - 2027" and "2026 – 2027" (en dash) all show as "2026-2027".
 * documents.fy_year is free text and keeps whatever the client sent, and the
 * Financial Year master names years "2026-27"; only the display is changed.
 * Values that are not a consecutive year range are shown as-is, spaces
 * around the dash removed.
 */
export function formatFyYear(value: string | null | undefined): string {
    if (value === null || value === undefined) return '';
    const tidy = String(value).trim().replace(/(\d)\s*[-–—]\s*(\d)/g, '$1-$2');
    const short = tidy.match(/^(\d{4})-(\d{2})$/);
    if (short && Number(short[2]) === (Number(short[1]) + 1) % 100) {
        return `${short[1]}-${Number(short[1]) + 1}`;
    }
    return tidy;
}

@Pipe({ name: 'fyYear', standalone: true })
export class FyYearPipe implements PipeTransform {
    transform(value: string | null | undefined): string {
        return formatFyYear(value);
    }
}
